import { Button, Divider } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "styled-components";
import { FacebookOutlined, ShareAltOutlined } from "@ant-design/icons";

import { Text } from "../../helpers/StyledComponents";
import { TabletSize } from "../../constant";
import NoData from "../../components/NoData/NoData";
import Loading from "../../components/Common/Loading";
import { Helmet } from "react-helmet";

import ActivitiesJson from "./activities.json";

const URL = "https://su-thailand.org/";

const Activities = () => {
  const location = useLocation();
  const [actNo, setActNo] = useState("");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const pathReplaced = `activities?actNo=${actNo}`;

  const shareToFacebook = () => {
    const shareUrl = `${URL}${pathReplaced}`;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareUrl
      )}`,
      "_blank"
    );
  };

  const shareToLine = () => {
    window.open(
      `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        `${URL}${pathReplaced}`
      )}`,
      "_blank"
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const actNoParam = searchParams.get("actNo");

    if (actNoParam) {
      setActNo(actNoParam);
    }
  }, [location.search]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const entry = ActivitiesJson.find((item) => item.actNo === actNo);
        if (entry) {
          const parser = new DOMParser();
          const parsedHTML = parser.parseFromString(entry.detail, "text/html");
          const links = parsedHTML.querySelectorAll("a");

          links.forEach((link) => {
            link.setAttribute("target", "_blank");
          });

          const modifiedHTML = parsedHTML.documentElement.innerHTML;
          setData({ ...entry, detail: modifiedHTML });
        } else {
          setData(null);
        }
      } catch (err) {
        console.error("Error fetching JSON:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [actNo]);

  return (
    <>
      <Helmet>
        <title>กิจกรรม - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <Loading isLoading={loading}>
        <div style={{ minHeight: "100dvh" }}>
          <Container>
            <Text fontSize="45" fontSizeMb="25" color="white">
              ข่าวสารและกิจกรรมล่าสุด
            </Text>
            <Text fontSize="35" fontSizeMb="20" color="white">
              {data?.title}
            </Text>
          </Container>
          <ContentContainer>
            {data ? (
              <>
                <ActContainer>
                  {data.images.map((img, index) => (
                    <ActImage key={index} src={img.image} alt="" />
                  ))}
                </ActContainer>
                <ContentText
                  dangerouslySetInnerHTML={{ __html: data?.detail }}
                />
                <Divider />
                <ButtonSection>
                  <Button type="primary" onClick={shareToFacebook}>
                    <ButtonText>
                      <FacebookOutlined />
                      แชร์ไปยัง Facebook
                    </ButtonText>
                  </Button>
                  <Button
                    type="primary"
                    onClick={shareToLine}
                    style={{ background: "#06C755" }}
                  >
                    <ButtonText>
                      <ShareAltOutlined />
                      แชร์ไปยัง Line
                    </ButtonText>
                  </Button>
                </ButtonSection>
              </>
            ) : (
              <NoData />
            )}
          </ContentContainer>
        </div>
      </Loading>
    </>
  );
};

const Container = styled.div`
  background: linear-gradient(
    89deg,
    rgb(21, 74, 189) 0.1%,
    rgb(26, 138, 211) 51.5%,
    rgb(72, 177, 234) 100.2%
  );
  height: 300px;
  display: flex;
  gap: 8px;
  padding: 20px;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ContentContainer = styled.div`
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;

  @media (max-width: ${TabletSize}px) {
    padding: 20px;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: ${TabletSize}px) {
    justify-content: center;
  }
`;

const ButtonText = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.div`
  font-size: calc(1em + 4px);
  line-height: calc(1em + 12px);
`;

const ActContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const ActImage = styled.img`
  width: 100%;
  max-width: 700px;
`;
export default Activities;
